<template>
  <div class="comic-detail" :style="getPageBackgroundStyle()">
    <ComicDetailIntro
      :comic="comic"
      :synop-ref="synopRef"
      :is-description-expanded="isDescriptionExpanded"
      :button-top="buttonTop"
      :should-show-toggle-button="shouldShowToggleButton"
      :is-collect="isCollect"
      :button-text="buttonText"
      :reward-button-text="rewardButtonText"
      :toggle-description="toggleDescription"
      :go-to-read-or-continue="goToReadOrContinue"
      :has-read-progress="hasReadProgress"
      :handle-collect="handleCollect"
      :handle-reward="handleReward"
    />

    <div class="content-source">
      <div class="detail-main-row">
        <div class="content-container">
          <div class="tab-content">
            <ComicDetailVolumeList
              v-model:current-volume-group-index="currentVolumeGroupIndex"
              :volume-groups="volumeGroups"
              :displayed-chapters="displayedChapters"
              :has-volume-progress="hasVolumeProgress"
              :get-volume-progress="getVolumeProgress"
              :is-volume-restricted="isVolumeRestricted"
              :get-volume-access="getVolumeAccess"
              :go-to-reading-page="goToReadingPage"
            />
            <el-divider />
            <ComicDetailComments
              v-model:comment-content="commentContent"
              v-model:comment-input-focused="commentInputFocused"
              :comments="comments"
              :comment-total="commentTotal"
              :comment-pages="commentPages"
              :comment-page-num="commentPageNum"
              :comment-page-size="commentPageSize"
              :loading-comments="loadingComments"
              :submitting-comment="submittingComment"
              :reply-content-map="replyContentMap"
              :show-reply-box-map="showReplyBoxMap"
              :submitting-reply-map="submittingReplyMap"
              :pending-expand-replies-map="pendingExpandRepliesMap"
              :show-all-replies-map="showAllRepliesMap"
              :like-effect-map="likeEffectMap"
              :submit-comment="submitComment"
              :toggle-reply-box="toggleReplyBox"
              :submit-comment-reply="submitCommentReply"
              :toggle-comment-replies="toggleCommentReplies"
              :toggle-show-all-replies="toggleShowAllReplies"
              :delete-comic-comment="deleteComicComment"
              :delete-comic-reply="deleteComicReply"
              :like-comment="likeComment"
              :like-reply="likeReply"
              :handle-comment-page-change="handleCommentPageChange"
            />
          </div>
        </div>

        <ComicDetailRelated
          :related-comics="relatedComics"
          :go-to-comic-detail="goToComicDetail"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRef } from 'vue'
import ComicDetailIntro from '@/features/comic/components/ComicDetailIntro.vue'
import ComicDetailVolumeList from '@/features/comic/components/ComicDetailVolumeList.vue'
import ComicDetailComments from '@/features/comic/components/ComicDetailComments.vue'
import ComicDetailRelated from '@/features/comic/components/ComicDetailRelated.vue'
import { useComicDetailPage } from '@/features/comic/composables/useComicDetailPage'

const props = defineProps({
  id: {
    type: [String, Number],
    default: null,
  },
})

const emit = defineEmits(['show-popup-message', 'show-login-popup'])

const {
  synopRef,
  comic,
  relatedComics,
  isDescriptionExpanded,
  buttonTop,
  shouldShowToggleButton,
  currentVolumeGroupIndex,
  volumeGroups,
  displayedChapters,
  comments,
  commentContent,
  commentInputFocused,
  submittingComment,
  commentTotal,
  commentPages,
  commentPageNum,
  commentPageSize,
  loadingComments,
  replyContentMap,
  showReplyBoxMap,
  submittingReplyMap,
  pendingExpandRepliesMap,
  showAllRepliesMap,
  likeEffectMap,
  isCollect,
  buttonText,
  rewardButtonText,
  getPageBackgroundStyle,
  toggleDescription,
  goToReadOrContinue,
  hasReadProgress,
  handleCollect,
  handleReward,
  goToReadingPage,
  hasVolumeProgress,
  getVolumeProgress,
  isVolumeRestricted,
  getVolumeAccess,
  submitComment,
  toggleReplyBox,
  submitCommentReply,
  toggleCommentReplies,
  toggleShowAllReplies,
  deleteComicComment,
  deleteComicReply,
  likeComment,
  likeReply,
  handleCommentPageChange,
  goToComicDetail,
} = useComicDetailPage(toRef(props, 'id'), emit)
</script>

<style src="@/features/comic/styles/ComicDetail.css"></style>
